import React from "react";

export interface ScoreCardProps {
  score: number | React.ReactNode;
  title: string;
  color: string;
  backgroundColor?: string;
}

const ScoreCard: React.FC<ScoreCardProps> = ({
  score,
  title,
  color,
  backgroundColor,
}) => {
  return (
    <div
      className="score-card"
      style={{ backgroundColor: backgroundColor || `${color}1A` }}
    >
      <div className="score-value" style={{ color }}>
        {score}
      </div>
      <div className="score-title" style={{ color }}>
        {title}
      </div>
    </div>
  );
};

export default ScoreCard;
